// @ts-nocheck
import { useState, useEffect } from "react";
import {
  Box, Button, Container, Grid2 as Grid, Modal, Typography,
  Backdrop, CircularProgress
} from "@mui/material";
import { Navigate, useNavigate } from "react-router-dom";

import { MODAL_MESSAGES } from "../../components/common/helpers";
import FormInversionWS from "../../components/investments/FormInversionWS";
import TransferenciasWS from "../../components/investments/TranferenciasWS";
import {
  uploadInvestment, addInvestment, sendEmailApproval, sendEmailAdmin
} from "../../actions/investments";
import { getEmpresas } from '../../actions/empresas';
import { getServicios } from "../../actions/servicios";

import { useDispatch, useSelector } from "react-redux";

const InvestmentWService = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isAuthenticated = useSelector(state => state.auth.isAuthenticated);
  const user = useSelector(state => state.users.user);
  const empresasAll = useSelector(state => state.empresas.empresas);

  const [newInvestment, setNewInvestment] = useState({
    servicio: "",
    monto: "",
    type: "paypal",
    card: "",
    exp: "",
    cvv: "",
  });
  const [errors, setErrors] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState({});
  const [loading, setLoading] = useState(false);
  const [empresa, setEmpresa] = useState('');
  const [servicios, setServicios] = useState([]); //Este estado guarda los servicios disponibles para mostrar en el formulario.
  const [servicioT, setServicioT] = useState(''); //Este estado guarda el servicio que se quiere contratar solo en la transferencia.
  const [montoT, setMontoT] = useState('');
  const [conceptoT, setConceptoT] = useState('');

  //Redirect
  if (!isAuthenticated) {
    return <Navigate to="/" />
  }

  if (user && user.datos_empresas?.[0]?.status !== 1) {
    return <Navigate to="/datos-fiscales" />
  }

  useEffect(() => {
    obtenerServicios();
    dispatch(getEmpresas());
  }, []);

  const obtenerServicios = async () => {
    const res = await getServicios();
    return setServicios(res);
  }

  const handleChange = (key, newValue) => {
    const newData = Object.assign({}, newInvestment);

    newData[key] = newValue;

    setNewInvestment(newData);
    setErrors({});
  }

  const uploadFile = async files => {
    if (files && files.length > 0) {
      setLoading(true);

      const uploadedReceipts = [];

      try {
        for (const archivo of files) {
          const formData = new FormData();
          const originalName = archivo.name.split('.').slice(0, -1).join('.');
          formData.append('file', archivo);
          formData.append('carpeta', `inversiones_index_dos/${user._id}`);
          formData.append('nombre', originalName);

          await dispatch(uploadInvestment(formData)); // Upload to Cloudinary
          uploadedReceipts.push(originalName); // Store the name/id used
        }

        const info = {
          recibo: uploadedReceipts, // Now an array
          monto: montoT,
          concepto: conceptoT,
          empresa,
          servicioEmpresa: servicioT,
          tipo: "Servicio"
        }

        const resUser = await dispatch(addInvestment(info, user._id, user.datos_empresas[0]._id));

        // Obtener nombre de la empresa y folio
        const selectedEmpresa = empresasAll.find(e => e._id === empresa);
        const razonSocial = selectedEmpresa ? selectedEmpresa.razon : 'N/A';
        const lastInv = resUser.datos_empresas[0].inversiones[resUser.datos_empresas[0].inversiones.length - 1];
        const folio = lastInv ? lastInv.folio : 'N/A';

        const emailInfo = {
          email: user.email,
          nombre: user.name,
          subject: 'confirmacion',
          servicio: true,
          empresa_servicio: razonSocial,
          fecha_pedido: new Date().toLocaleDateString(),
          folio: folio,
          concepto: conceptoT,
          monto: montoT
        };

        await sendEmailApproval(emailInfo);
        await dispatch(sendEmailAdmin());

        const result = MODAL_MESSAGES.SUCCESS_DOC;
        setModalContent(result);
        setLoading(false);
        setShowModal(true);
        // Clean files in child component? The child component has its own state, let it persist or user can clear manually by refresh or navigation.

      } catch (error) {
        console.error("Error uploading files", error);
        setLoading(false);
        // Handle error appropriately
      }
    }
  }

  return (
    <>
      <Modal
        open={showModal}
        className="modal-content"
        onClose={() => setShowModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="modal-message modal-large">
          {modalContent.img && <img alt="modal-img" src={modalContent.img} />}
          <Typography className="titleMain" variant="h3" component="h3" mt={3}>
            {modalContent.title ?? '--'}
          </Typography>
          <Typography mt={3} mb={5}>
            {modalContent.subtitle ?? '--'}
          </Typography>
          <Button
            onClick={() => navigate('../detalle-inversiones')}
            type="button"
            variant="contained"
          >
            {modalContent.btnAction ?? 'OK'}
          </Button>
        </Box>
      </Modal>

      <section className="segment-header">
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={loading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        <div className="transbox" />
        <Container className="content-headers" component="main" maxWidth="lg">
          <div>
            <Typography className="title" variant="h1" component="h1">
              Contratar servicio
            </Typography>
          </div>
        </Container>
      </section>

      <Grid className="payment-section" container spacing={5}>
        <Grid className="content-form" size={{ md: 6, xl: 7 }} mt={5}>
          <FormInversionWS
            user={user}
            servicios={servicios}
            errors={errors}
            newInvestment={newInvestment}
            handleChange={handleChange}
            setModalContent={setModalContent}
            setShowModal={setShowModal}
            setLoading={setLoading}
          />
        </Grid>
        <Grid size={{ md: 6, xl: 5 }} mt={{ xs: 3, md: 5 }}>
          <TransferenciasWS
            servicio={servicioT}
            setServicio={setServicioT}
            monto={montoT}
            setMonto={setMontoT}
            concepto={conceptoT}
            setConcepto={setConceptoT}
            uploadFile={uploadFile}
            empresa={empresa}
            setEmpresa={setEmpresa}
            loading={loading}
          />
        </Grid>
      </Grid>
    </>
  );
}

export default InvestmentWService;
